import styled from 'styled-components';

export const TextButton = styled.div<{
  $isActive?: boolean;
  $type?: 'primary' | 'secondary';
}>`
  cursor: pointer;
  padding: 5px 10px;
  border-radius: var(--radius-2);
  background-color: var(--neutral-2);
  color: var(--main-2);
  font-size: 12px;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: var(--neutral-3);
    color: var(--main-1);
  }

  ${({ $type }) =>
    $type === 'primary' &&
    `
    border: 1px solid var(--primary-2);
    color: var(--primary-1);

    &:hover {
      border: 1px solid var(--primary-1);
      color: var(--primary-1);
      background-color: var(--neutral-2);
    }
  `}

  ${({ $type }) =>
    $type === 'secondary' &&
    `
    border: 1px solid var(--neutral-3);

    &:hover {
      border: 1px solid var(--main-2);
      background-color: var(--neutral-2);
    }
  `}

  ${({ $isActive }) =>
    $isActive &&
    `
    background-color: var(--neutral-3);
    color: var(--main-1);
    &:hover {
      background-color: var(--neutral-3);
      color: var(--main-1);
    }
  `}

  transition: background-color 0.3s, color 0.3s, border 0.3s;
`;
